export default function accountNavContent() {
    return import(/* webpackChunkName: "accountNavContent" */
    './AccountNavContent').then(mod => {
        return mod.default;
    });
}
